module.exports = __webpack_public_path__ + "static/media/MANUFACTURING.3b51d2f1.png";